import { useState } from "react";
import { ExpandableProps } from "../../utils/types";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

export const Expandable = (props: ExpandableProps) => {
    const { title, component } = props;

    const [showContent, setShowContent] = useState<boolean>(false);

    return (
        <div className="expandable-container" id={`${title.toLowerCase()}-expandable`}>
            <div className="expandable-bar">
                <p>{showContent ? <b>{title}</b> : title}</p>

                <button className="expandable-button" onClick={() => setShowContent(!showContent)}>
                    {!showContent && <BsChevronDown size={20} />}
                    {showContent && <BsChevronUp size={20} />}
                </button>
            </div>
            {showContent && <div className="expanded-container">{component}</div>}
        </div>
    );
};
